<template>
    <modal v-if="$root.showModal">
        <div 
            slot="header" 
            class="col-12">
            <h4 
                class="modal-title box-title" 
                style="line-height: 36px">
                Ustvari nov vir
            </h4>
            <button 
                type="button" 
                class="close"
                aria-label="Zapri"
                @click.prevent="$root.closeModal">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div slot="body">
            <form 
                role="form" 
                @submit.prevent="addItem">
                <div class="box-body">
                    <div class="form-group">
                        <label for="name">Ime</label>
                        <input 
                            id="name"
                            v-model="newItem.name"
                            type="text"
                            class="form-control"
                            placeholder="Ime"
                            required>
                    </div>

                    <div class="form-group">
                        <input 
                            id="has_job_class"
                            v-model="newItem.has_job_class"
                            type="checkbox">
                        <label for="has_job_class">Uporabi Job class</label>
                    </div>

                    <template v-if="newItem.has_job_class">

                        <div class="form-group">
                            <label for="job_class_name">Job class</label>
                            <input 
                                id="job_class_name"
                                v-model="newItem.job_class_name"
                                type="text"
                                class="form-control"
                                placeholder="Job class"
                                required>
                        </div>
                        <div class="form-group">
                            <input 
                                id="api"
                                v-model="newItem.api"
                                :required="!newItem.connection || !newItem.table"
                                type="checkbox">
                            <label for="api">Zunanji API</label>
                        </div>
                        <div class="form-group">
                            <input 
                                id="auto_update"
                                v-model="newItem.auto_update"
                                type="checkbox">
                            <label for="auto_update">Avtomatsko posodabljaj</label>
                        </div>
                        <div class="form-group">
                            <label for="connection">Povezava / podatkovna baza</label>
                            <select 
                                id="connection" 
                                v-model="newItem.connection"
                                :disabled="newItem.api"
                                :required="!newItem.api"
                                class="form-control">
                                <option 
                                    selected 
                                    disabled>Izberite povezavo / podatkovno bazo</option>
                                <option 
                                    v-for="connection in connections" 
                                    :key="connection.id"
                                    :value="connection">{{ connection }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="table">Tabela</label>
                            <input 
                                id="table"
                                v-model="newItem.table"
                                :disabled="newItem.api"
                                :required="!newItem.api"
                                type="text"
                                class="form-control"
                                placeholder="Tabela">
                        </div>

                    </template>

                    <!--div class="form-group">
                        <label for="example">Barvna shema oznake</label>
                        <div class="col-sm-12 text-center margin-bottom">
                            <span 
                                id="example" 
                                :style="{color: newItem.color, backgroundColor: newItem.background_color, fontSize: '20px'}"
                                class="label">
                                {{ newItem.name || 'Nov vir' }}
                            </span>
                        </div>
                        <div class="col-sm-6">
                            <label for="color">Tekst</label>
                            <sketch-picker 
                                id="color"
                                :value="newItem.color"
                                @input="changeColor"/>
                        </div>
                        <div class="col-sm-6">
                            <label for="background_color">Ozadje</label>
                            <sketch-picker 
                                id="background_color"
                                :value="newItem.background_color"
                                @input="changeBackgroundColor"/>
                        </div>
                    </div-->
                </div>
                <div class="box-footer">
                    <button 
                        type="submit" 
                        class="btn btn-success">Shrani</button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
import Modal         from './../Modal.vue';
import NewItem       from '../../mixins/NewItem';
import SourcesCommon from '../../mixins/Sources';
//import {Sketch}      from 'vue-color';

export default {
    name: 'NewSource',

    components: {
        Modal,
        //'sketch-picker': Sketch,
    },

    mixins: [
        NewItem,
        SourcesCommon
    ],

    data() {
        return {
            newItem: {
                name:             null,
                has_job_class:    false,
                api:              false,
                auto_update:      false,
                connection:       null,
                table:            null,
                job_class_name:   null,
                color:            '#444444',
                background_color: '#d2d6de'
            }
        };
    },

    methods: {
        resetNewItem() {
            this.$set(this.newItem, 'name', null);
            this.$set(this.newItem, 'api', false);
            this.$set(this.newItem, 'auto_update', false);
            this.$set(this.newItem, 'connection', null);
            this.$set(this.newItem, 'table', null);
            this.$set(this.newItem, 'job_class_name', null);
            this.$set(this.newItem, 'color', '#444444');
            this.$set(this.newItem, 'background_color', '#d2d6de');
        },

        prepareNewItemData() {
            if (!this.newItem.has_job_class) {
                this.$set(this.newItem, 'api', false);
                this.$set(this.newItem, 'auto_update', false);
                this.$set(this.newItem, 'connection', null);
                this.$set(this.newItem, 'table', null);
                this.$set(this.newItem, 'job_class_name', null);
            }

            return (({name, has_job_class, connection, table, api, auto_update, job_class_name, color, background_color}) =>
                ({name, has_job_class, connection, table, api, auto_update, job_class_name, color, background_color})
            )(this.newItem);
        },

        /*changeColor(value) {
            this.$set(this.newItem, 'color', value.hex);
        },

        changeBackgroundColor(value) {
            this.$set(this.newItem, 'background_color', value.hex);
        },*/
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Sources/NewSource.vue